import { render, staticRenderFns } from "./editGroupsList.vue?vue&type=template&id=efc1e86c"
import script from "./editGroupsList.vue?vue&type=script&lang=ts"
export * from "./editGroupsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports